"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslatedCurrency = void 0;
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var useTranslatedCurrency = function useTranslatedCurrency(code) {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return "".concat(t("currencies.".concat(code)), " (").concat(code, ")");
};
exports.useTranslatedCurrency = useTranslatedCurrency;